<div class="service-info">
  <div class="service-info__text-container">
    <div class="service-info__text-wrapper">
      <h2 [innerHTML]="'SERVICE_INFO.DESCRIPTION.TITLE' | translate"></h2>
      @for (text of 'SERVICE_INFO.DESCRIPTION.DESCRIPTION' | translate; track text) {
        <p>{{ text }}</p>
      }
      <section>
        <h4>{{ 'SERVICE_INFO.DESCRIPTION.CONDITIONS.TITLE' | translate }}</h4>
        <p [innerHTML]="'SERVICE_INFO.DESCRIPTION.CONDITIONS.APR' | translate"></p>
        <p [innerHTML]="'SERVICE_INFO.DESCRIPTION.CONDITIONS.FIRST_CREDIT_NOTE' | translate"></p>
        <p [innerHTML]="'SERVICE_INFO.DESCRIPTION.CONDITIONS.TERM.TITLE' | translate"></p>
        <ul>
          <li [innerHTML]="'SERVICE_INFO.DESCRIPTION.CONDITIONS.TERM.MIN' | translate: { value: mockProduct.fullTerm }"></li>
          <li [innerHTML]="'SERVICE_INFO.DESCRIPTION.CONDITIONS.TERM.MAX' | translate: { value: mockProduct.fullTerm }"></li>
        </ul>
        <p
          [innerHTML]="
            'SERVICE_INFO.DESCRIPTION.CONDITIONS.AMOUNT'
              | translate: { min: mockProduct.minAmount | formatNumber, max: mockProduct.maxAmount | formatNumber }
          "
        ></p>
        <p [innerHTML]="'SERVICE_INFO.DESCRIPTION.CONDITIONS.AGE' | translate"></p>
        <p [innerHTML]="'SERVICE_INFO.DESCRIPTION.CONDITIONS.DOCUMENTS' | translate"></p>
      </section>

      <p
        [innerHTML]="
          'SERVICE_INFO.DESCRIPTION.EXAMPLE'
            | translate: { min: mockProduct.minAmount | formatNumber, max: mockProduct.maxAmount | formatNumber }
        "
      ></p>

      <section>
        <h4>{{ 'SERVICE_INFO.DESCRIPTION.WARNINGS.TITLE' | translate }}</h4>
        <ul>
          <li [innerHTML]="'SERVICE_INFO.DESCRIPTION.WARNINGS.CHANGES' | translate"></li>
          <li [innerHTML]="'SERVICE_INFO.DESCRIPTION.WARNINGS.EXTENSION' | translate"></li>
          <li [innerHTML]="'SERVICE_INFO.DESCRIPTION.WARNINGS.LATE_PAYMENT' | translate"></li>
          <li [innerHTML]="'SERVICE_INFO.DESCRIPTION.WARNINGS.DECISION' | translate"></li>
        </ul>
      </section>

      <section>
        <h4>{{ 'SERVICE_INFO.DESCRIPTION.PAYMENT_METHODS.TITLE' | translate }}</h4>
        <ul>
          <li [innerHTML]="'SERVICE_INFO.DESCRIPTION.PAYMENT_METHODS.SITE' | translate"></li>
          <li [innerHTML]="'SERVICE_INFO.DESCRIPTION.PAYMENT_METHODS.TERMINAL' | translate"></li>
          <li [innerHTML]="'SERVICE_INFO.DESCRIPTION.PAYMENT_METHODS.TRANSFER' | translate"></li>
        </ul>
      </section>

      <p>{{ 'SERVICE_INFO.DESCRIPTION.RECOMMENDATION' | translate }}</p>
    </div>
  </div>
  <div class="service-info__tags">
    @for (tag of 'SERVICE_INFO.TAGS' | translate; track tag; let activeTag = $first) {
      <p [class.active]="activeTag" class="service-info__tags-item">{{ tag }}</p>
    }
  </div>
</div>
<!--'SERVICE_INFO.DESCRIPTION.' | translate-->
